export const getDataTableSortFields = (searchParams) => {
    const sortField = searchParams.sortBy;
    const sortOrder = searchParams.sortDir === "asc" ? 1 : -1;
    return { sortField, sortOrder };
}

export const getSearchParamSortFields = (sortField, sortOrder) => {
    const sortBy= sortField;
    const sortDir = sortOrder === 1 ? "asc" : "desc";
    return { sortBy, sortDir }
}